var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isExcepcional)?_c('v-chip',{staticClass:"excepcional-label",attrs:{"x-small":"","label":"","color":"deep-orange lighten-5","text-color":"deep-orange darken-3"}},[_c('v-icon',{attrs:{"x-small":"","left":""}},[_vm._v("mdi-swap-horizontal-bold")]),_vm._v(" Movimiento excepcional ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }